module.exports = __webpack_public_path__ + "img/inBank.bfd217b7.svg";